import MainConnection from "./MainConnection";

export default {
  requestDeviceList: async function(page) {
    try {
      const requestURL = "/devices?page=" + page;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestFilteredDeviceList: async function(params) {
    try {
      const requestURL =
        "/devices?page=" + params.page + "&search=" + params.filter;
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateNewDevices: async function(batch) {
    try {
      const requestURL = "/devices";
      const response = await MainConnection.request().post(requestURL, {
        batch
      });
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestRemoveDeviceById: async function(device_id) {
    try {
      const requestURL = "/devices/" + device_id;
      const response = await MainConnection.request().delete(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
